import { ActionMeta, OptionsType } from 'react-select';
import { track } from '../../../../tracking';

type Item = {
    id: string;
};

export const handleKeyDownEvent = <ListItem extends Item>({
    event,
    focussedItemId,
    leftList,
    rightList,
    setFocus,
    onSelect,
    scrollIntoView,
    isMenuOpen,
    onDownArrow,
}: {
    event: React.KeyboardEvent<HTMLElement>;
    focussedItemId: string | undefined;
    leftList: ListItem[];
    rightList: ListItem[];
    setFocus: (id: string | undefined) => void;
    scrollIntoView: (id: string) => void;
    onDownArrow?: (event: React.KeyboardEvent<HTMLElement>) => void;
    isMenuOpen: boolean;
    onSelect: (selectedValues: OptionsType<ListItem>, action: ActionMeta<ListItem>) => void;
}): void => {
    switch (event.key) {
        case 'ArrowRight':
            {
                track('AS_KEYBOARD_HANDLER', { key: event.key });
                if (focussedItemId) {
                    const isSym = leftList.map((i) => i.id).indexOf(focussedItemId);
                    if (isSym !== -1) {
                        const newId =
                            rightList.length > isSym
                                ? rightList[isSym].id
                                : rightList.length > 0
                                ? rightList[rightList.length - 1].id
                                : focussedItemId;
                        setFocus(newId);
                        scrollIntoView(newId);

                        break;
                    }
                }
            }
            break;
        case 'ArrowLeft':
            {
                track('AS_KEYBOARD_HANDLER', { key: event.key });
                if (focussedItemId) {
                    const isDia = rightList.map((i) => i.id).indexOf(focussedItemId);
                    if (isDia !== -1) {
                        const newId =
                            leftList.length > isDia
                                ? leftList[isDia].id
                                : leftList.length > 0
                                ? leftList[leftList.length - 1].id
                                : focussedItemId;
                        setFocus(newId);
                        scrollIntoView(newId);
                        break;
                    }
                }
            }
            break;
        case 'ArrowUp':
            {
                track('AS_KEYBOARD_HANDLER', { key: event.key });
                if (focussedItemId) {
                    const isSym = leftList.map((i) => i.id).indexOf(focussedItemId);
                    let newId = focussedItemId;
                    if (isSym !== -1) {
                        newId =
                            isSym - 1 >= 0
                                ? leftList[isSym - 1].id
                                : rightList.length > 0
                                ? rightList[rightList.length - 1].id
                                : focussedItemId;
                    } else {
                        const isDia = rightList.map((i) => i.id).indexOf(focussedItemId);
                        if (isDia !== -1) {
                            newId =
                                isDia > 0
                                    ? rightList[isDia - 1].id
                                    : leftList.length > 0
                                    ? leftList[leftList.length - 1].id
                                    : focussedItemId;
                        }
                    }

                    setFocus(newId);

                    scrollIntoView(newId);
                }
                event.preventDefault();
            }
            break;
        case 'ArrowDown':
            {
                track('AS_KEYBOARD_HANDLER', { key: event.key });
                if (focussedItemId && isMenuOpen) {
                    const isSym = leftList.map((i) => i.id).indexOf(focussedItemId);
                    let newId = focussedItemId;
                    if (isSym !== -1) {
                        newId =
                            isSym === leftList.length - 1
                                ? rightList.length > 0
                                    ? rightList[0].id
                                    : focussedItemId
                                : leftList[isSym + 1].id;
                    } else {
                        const isDia = rightList.map((i) => i.id).indexOf(focussedItemId);
                        if (isDia !== -1) {
                            newId =
                                isDia === rightList.length - 1
                                    ? leftList.length > 0
                                        ? leftList[0].id
                                        : focussedItemId
                                    : rightList.length > isDia + 1
                                    ? rightList[isDia + 1].id
                                    : focussedItemId;
                        }
                    }

                    setFocus(newId);

                    scrollIntoView(newId);
                    event.preventDefault();
                }

                if (onDownArrow) onDownArrow(event);
            }
            break;
        case 'Enter':
            track('AS_KEYBOARD_HANDLER', { key: event.key });
            event.preventDefault();
            if (event.keyCode === 229) {
                // ignore the keydown event from an Input Method Editor(IME)
                // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
                break;
            }
            if (!isMenuOpen || !focussedItemId) {
                break;
            }
            const option =
                leftList.find((i) => i.id === focussedItemId) ||
                rightList.find((i) => i.id === focussedItemId);
            if (option) onSelect([option], { option: option, action: 'select-option' });

            break;
    }
};
